import { ChangeDetectionStrategy, ChangeDetectorRef, Component, signal } from '@angular/core';
import { CommonModule } from 'src/common/common.module';
import { FabEvent } from 'src/common/events';
import { Fab } from 'src/common/models';

@Component({
  selector: 'app-fab-outlet',
  imports: [CommonModule],
  templateUrl: './fab-outlet.component.html',
  styleUrl: './fab-outlet.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FabOutletComponent {
  fabs = signal<Fab[]>([]);
  constructor(private change: ChangeDetectorRef) {
    FabEvent.addEventListener(
      fab => this.fabs.update(fabs => { fabs.push(fab); this.change.markForCheck(); return fabs; }),
      fab => this.fabs.update(fabs => { fabs.splice(fabs.findIndex(f => f.id == fab.id), 1); this.change.markForCheck(); return fabs; })
    )
  }
}
